import { render, staticRenderFns } from "./TrendingKeywordsSection.vue?vue&type=template&id=39323c21&scoped=true&lang=pug"
import script from "./TrendingKeywordsSection.vue?vue&type=script&lang=js"
export * from "./TrendingKeywordsSection.vue?vue&type=script&lang=js"
import style0 from "./TrendingKeywordsSection.vue?vue&type=style&index=0&id=39323c21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39323c21",
  null
  
)

export default component.exports